module.exports = __webpack_public_path__ + "static/credits-f5238555e7f1b2582f872d20488f55e4.png";